import { jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import tableStyles from "./components/Table/styles.module.scss";
import { M as ModeType } from "./Table.js";
const TableBody = ({ className, children, mode = ModeType.normal, ...rest }) => {
  const tableBodyClasses = classNames(tableStyles["table-body"], className);
  return /* @__PURE__ */ jsx("tbody", { className: tableBodyClasses, ...rest, children: React__default.Children.map(children, (child) => React__default.isValidElement(child) && React__default.cloneElement(child, { mode })) });
};
export {
  TableBody as T
};
//# sourceMappingURL=TableBody.js.map
